import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": /*@__PURE__*/_normalizeClass(['service'])
};
var _hoisted_2 = {
  "class": /*@__PURE__*/_normalizeClass(['service-header'])
};
var _hoisted_3 = {
  "class": /*@__PURE__*/_normalizeClass(['service-header-title'])
};
var _hoisted_4 = ["href"];
var _hoisted_5 = {
  key: 0,
  "class": /*@__PURE__*/_normalizeClass(['service-list'])
};
var _hoisted_6 = ["href"];
var _hoisted_7 = {
  key: 1,
  "class": /*@__PURE__*/_normalizeClass(['service-list-item-key'])
};
var _hoisted_8 = {
  "class": /*@__PURE__*/_normalizeClass(['service-description', 'description'])
};
var _hoisted_9 = {
  key: 1,
  "class": "evaluate"
};
var _hoisted_10 = {
  "class": /*@__PURE__*/_normalizeClass(['evaluate-description', 'description'])
};
var _hoisted_11 = {
  key: 0,
  "class": "evaluate-list"
};
var _hoisted_12 = {
  key: 2,
  "class": "order"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  "class": "order-main"
};
var _hoisted_15 = {
  "class": "order-main-title"
};
var _hoisted_16 = {
  "class": /*@__PURE__*/_normalizeClass(['order-main-description', 'description'])
};
var _hoisted_17 = {
  "class": "order-main-price"
};
var _hoisted_18 = {
  key: 3,
  "class": "text-link"
};
var _hoisted_19 = {
  "class": /*@__PURE__*/_normalizeClass(['text-link-description', 'description'])
};
var _hoisted_20 = ["href"];
var _hoisted_21 = {
  key: 4
};
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, computed } from "../../../../../adapter-vue";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../../constant";
import { JSONToObject, isUrl } from "../../../../../utils/index";
import Icon from "../../../../common/Icon.vue";
import star from "../../../../../assets/icon/star-light.png";
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-custom',
  props: {
    contentText: {
      type: Array,
      "default": []
    },
    message: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    messageContent: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var _props$message, _props$messageContent;
    var props = __props;
    var custom = ref(props === null || props === void 0 || (_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.payload);
    var extensionJSON = computed(function () {
      var _custom$value;
      return JSONToObject(custom === null || custom === void 0 || (_custom$value = custom.value) === null || _custom$value === void 0 ? void 0 : _custom$value.data);
    });
    var businessID = computed(function () {
      var _extensionJSON$value;
      return extensionJSON === null || extensionJSON === void 0 || (_extensionJSON$value = extensionJSON.value) === null || _extensionJSON$value === void 0 ? void 0 : _extensionJSON$value.businessID;
    });
    var descriptionForShow = ref(props === null || props === void 0 ? void 0 : props.contentText);
    var defaultMessageContent = ref((props === null || props === void 0 || (_props$messageContent = props.messageContent) === null || _props$messageContent === void 0 ? void 0 : _props$messageContent.custom) || "[自定义消息]");
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['message-abstract-custom']),
        onClickCapture: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
      }, [_unref(businessID) === _unref(CHAT_MSG_CUSTOM_TYPE).SERVICE ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", _hoisted_2, [_createElementVNode("label", _hoisted_3, _toDisplayString(_unref(extensionJSON).title), 1), _unref(extensionJSON).hyperlinks_text ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        "class": _normalizeClass(['service-header-link', 'link']),
        href: _unref(extensionJSON).hyperlinks_text.value,
        target: "view_window"
      }, _toDisplayString(_unref(extensionJSON).hyperlinks_text.key), 9, _hoisted_4)) : _createCommentVNode("", true)]), _unref(extensionJSON).item && _unref(extensionJSON).item.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extensionJSON).item, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": _normalizeClass(['service-list-item']),
          key: index
        }, [_unref(isUrl)(item.value) ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          "class": _normalizeClass(['service-list-item-link', 'link']),
          href: item.value,
          target: "view_window"
        }, _toDisplayString(item.key), 9, _hoisted_6)) : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.key), 1))]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptionForShow), function (contentItem, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          "class": _normalizeClass([contentItem && contentItem.isHighlight ? 'highlight' : 'normal'])
        }, _toDisplayString(contentItem.text), 3);
      }), 128))])])) : _unref(businessID) === _unref(CHAT_MSG_CUSTOM_TYPE).EVALUATE ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptionForShow), function (contentItem, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          "class": _normalizeClass([contentItem && contentItem.isHighlight ? 'highlight' : 'normal'])
        }, _toDisplayString(contentItem.text), 3);
      }), 128))]), _unref(extensionJSON).score ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.max(_unref(extensionJSON).score, 0), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": "evaluate-list-item",
          key: index
        }, [_createVNode(Icon, {
          file: _unref(star),
          "class": "file-icon"
        }, null, 8, ["file"])]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("article", null, _toDisplayString(_unref(extensionJSON).comment), 1)])) : _unref(businessID) === _unref(CHAT_MSG_CUSTOM_TYPE).ORDER ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
        "class": "order-image",
        src: _unref(extensionJSON).imageUrl,
        alt: ""
      }, null, 8, _hoisted_13), _createElementVNode("main", _hoisted_14, [_createElementVNode("h1", _hoisted_15, _toDisplayString(_unref(extensionJSON).title), 1), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(descriptionForShow), function (contentItem, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index,
          "class": _normalizeClass([contentItem && contentItem.isHighlight ? 'highlight' : 'normal'])
        }, _toDisplayString(contentItem.text), 3);
      }), 128))]), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(extensionJSON).price), 1)])])) : _unref(businessID) === _unref(CHAT_MSG_CUSTOM_TYPE).LINK ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("p", null, _toDisplayString(_unref(extensionJSON).text), 1)]), _createElementVNode("a", {
        "class": _normalizeClass(['link']),
        href: _unref(extensionJSON).link,
        target: "view_window"
      }, _toDisplayString(_unref(TUITranslateService).t("message.custom.查看详情>>")), 9, _hoisted_20)])) : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(defaultMessageContent)), 1))], 32);
    };
  }
});